import React, { useMemo } from 'react'
import { FlowGrid } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { VIEW_FORMAT } from './panels/PreferencesPanel'
import HistoryChangeCard from './HistoryChangeCard'
import HistoryChangeList from './historyChangeList'
import { useR2StateContext } from '../../../providers/r2Provider/R2Context'

const containerCss = css`
  margin-top: 1.875rem;
`

const PersonChangesHistory = ({ filter, historyChanges, title, expanded }) => {
  const { historyFormat } = useR2StateContext()

  const historyCategories = useMemo(() => {
    return Array.from(
      new Map(
        historyChanges.map((change) => {
          const changeType =
            change?.typeData?.fieldType ||
            change?.typeData?.eventType ||
            change?.typeData?.relType ||
            change?.typeData?.recordType ||
            change?.typeData?.elementType

          return [changeType, { type: changeType, label: change.displayLabel }]
        })
      ).values()
    )
  }, [historyChanges])

  const groupedChanges = useMemo(() => {
    if (!Array.isArray(historyChanges) || historyCategories === null) {
      return {}
    }

    const groups = {}

    historyCategories.forEach((category) => {
      const changesByCategory = historyChanges.filter((change) => {
        const changeType =
          change?.typeData?.fieldType ||
          change?.typeData?.eventType ||
          change?.typeData?.relType ||
          change?.typeData?.recordType ||
          change?.typeData?.elementType

        return changeType === category.type
      })

      groups[category.type] = { label: category.label, items: changesByCategory }
    })

    return groups
  }, [historyChanges, historyCategories])

  const hasGroupedChanges = Object.keys(groupedChanges).length > 0

  return (
    <>
      {historyFormat === VIEW_FORMAT.group ? (
        <div css={containerCss}>
          <FlowGrid orientation="vertical">
            {hasGroupedChanges ? (
              Object.keys(groupedChanges).map((id) => (
                <HistoryChangeCard
                  key={id}
                  label={groupedChanges[id].label}
                  change={groupedChanges[id]}
                  expanded={expanded}
                />
              ))
            ) : (
              <HistoryChangeCard label={filter.label} change={{ items: [] }} expanded={expanded} />
            )}
          </FlowGrid>
        </div>
      ) : (
        <HistoryChangeList changes={historyChanges} title={title} />
      )}
    </>
  )
}

export default PersonChangesHistory
